(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function() {
    async function getPool() {
      const script = document.getElementById('upsell-liquid-data');
      try { return script ? JSON.parse(script.textContent) : []; } catch { return []; }
    }

    async function renderUpsellSlider() {
      const container = document.getElementById('cart-drawer-upsell-container');
      if (!container || container.dataset.initialized) return;
      container.dataset.initialized = 'true';

      const pool = await getPool();

      const cartIds = [];
      const available = pool;
      if (!available || available.length === 0) {
        container.innerHTML = '';
        container.style.display = 'none';
        return;
      }

      if (!container._selected || container._selected.length === 0) {
        container._selected = available.slice(0, 6);
      } else {
        container._selected = container._selected.filter(p => !cartIds.includes(p.id) && !cartIds.includes(Number(p.id)));
        if (container._selected.length === 0) {
          container._selected = available.slice(0, 6);
        }
      }

      const items = container._selected;
      if (!items || items.length === 0) {
        container.innerHTML = '';
        container.style.display = 'none';
        return;
      }

      container.style.display = 'block';

      const escapeHtml = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
      const slidesHtml = items.map((raw, index) => {
        const p = Object.fromEntries(Object.entries(raw).map(([key,value]) => [key,escapeHtml(value)]));
        const priceHtml = raw.price_html || `<span class="upsell-current-price">${p.price}</span>`;

        const imgHtml = p.img 
          ? `<img src="${p.img}" alt="${p.title.replace(/"/g, '&quot;')}" loading="lazy" width="75" height="75">`
          : `<div style="width:75px;height:75px;background:#f3f4f6;border-radius:8px;"></div>`;

        return `
          <div class="upsell-card-slide" role="group" aria-label="${index + 1} / ${items.length}" ${index ? 'inert' : ''}>
            <div class="upsell-card-inner" data-url="${p.url || '#'}">
              <div class="upsell-card-left"><div class="upsell-img-box">${imgHtml}</div></div>
              <div class="upsell-card-right">
                <h4 class="upsell-title"><a href="${p.url}">${p.title}</a></h4>
                <p class="upsell-subtitle">${p.variant_title || ''}</p>
                <div class="upsell-price-row">${priceHtml}</div>
              </div>
              <button type="button" class="upsell-add-btn" data-variant-id="${p.variant_id}" aria-label="${p.title} hinzufügen">
                <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
                  <circle cx="9" cy="20" r="1" fill="currentColor"/>
                  <circle cx="18" cy="20" r="1" fill="currentColor"/>
                </svg>
              </button>
            </div>
          </div>
        `;
      }).join('');

      const dotsHtml = items.map((_, i) => `<button type="button" aria-label="Vorschlag ${i+1}" class="upsell-dot ${i === 0 ? 'active' : ''}"></button>`).join('');

      container.innerHTML = `
        <p class="mm-cart-suggestion-label">${container.dataset.heading || ''}</p>
        <div class="upsell-slider-wrapper">
          <div class="upsell-slider-track">${slidesHtml}</div>
          <div class="upsell-nav-footer" ${items.length < 2 ? 'hidden' : ''}>
            <button type="button" class="mm-upsell-pause" aria-pressed="false">Wechsel pausieren</button>
            <div class="upsell-dots">${dotsHtml}</div>
            <div class="upsell-arrows">
              <button type="button" class="upsell-arrow-btn prev" aria-label="Zurück">
                <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2.5" fill="none"><path d="M15 18l-6-6 6-6"/></svg>
              </button>
              <button type="button" class="upsell-arrow-btn next" aria-label="Weiter">
                <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2.5" fill="none"><path d="M9 18l6-6-6-6"/></svg>
              </button>
            </div>
          </div>
        </div>
      `;
    }

    let autoAdvance;
    if (!window.mmUpsellRotationBound) {
      window.mmUpsellRotationBound = true;
      autoAdvance = setInterval(() => {
        const container = document.getElementById('cart-drawer-upsell-container');
        if (!container || !container.closest('dialog[open]') || document.hidden || container.dataset.paused === 'true' || container.matches(':hover') || container.contains(document.activeElement) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        container.querySelector('.upsell-arrow-btn.next')?.click();
      }, 6500);
      window.addEventListener('pagehide', () => clearInterval(autoAdvance), {once:true});
      document.addEventListener('scroll', event => {
        const track = event.target;
        if (!(track instanceof Element) || !track.matches('.upsell-slider-track')) return;
        const slides = [...track.querySelectorAll('.upsell-card-slide')];
        const step = slides[0]?.getBoundingClientRect().width + 10;
        const index = Math.round(track.scrollLeft / step);
        slides.forEach((slide,i) => { slide.inert = i !== index; });
        track.closest('#cart-drawer-upsell-container')?.querySelectorAll('.upsell-dot').forEach((dot,i) => dot.classList.toggle('active', i === index));
      }, true);
    }

    window.updateCartDrawerDOM = function(htmlString) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, 'text/html');

      const newInner = doc.querySelector('.cart-drawer__inner');
      const currentInner = document.querySelector('.cart-drawer__inner');

      if (newInner && currentInner) {
        currentInner.className = newInner.className;
        currentInner.innerHTML = newInner.innerHTML;
      }

      const newBadge = doc.querySelector('.theme-drawer__badge');
      const currentBadge = document.querySelector('.theme-drawer__badge');
      if (newBadge && currentBadge) {
        currentBadge.outerHTML = newBadge.outerHTML;
      }

      initCustomDiscount();
      renderUpsellSlider();
      const heading = document.getElementById('cart-drawer-heading');
      if (heading) { heading.tabIndex = -1; heading.focus({preventScroll:true}); }
    };

    window.refreshCartSection = function() {
      fetch('/cart?section_id=cart-drawer-section')
        .then(res => res.text())
        .then(html => window.updateCartDrawerDOM(html))
        .catch(err => console.error('Fehler beim Aktualisieren:', err));
    };

    function initCustomDiscount() {
      const btn = document.getElementById('CustomDiscountBtnDrawer');
      const input = document.getElementById('CustomDiscountInputDrawer');

      if (btn && input && !btn.dataset.discountBound) {
        btn.dataset.discountBound = 'true';
        function applyDiscountCode() {
          const code = input.value.trim();
          if (!code) return;
          btn.disabled = true;
          btn.textContent = '...';

          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ discount: code, sections: ['cart-drawer-section'] })
          })
          .then(res => res.json())
          .then(data => {
            btn.disabled = false;
            btn.textContent = 'Anwenden';
            if (data.sections && data.sections['cart-drawer-section']) {
              window.updateCartDrawerDOM(data.sections['cart-drawer-section']);
            } else {
              window.refreshCartSection();
            }
          })
          .catch(() => {
            btn.disabled = false;
            btn.textContent = 'Anwenden';
          });
        }

        btn.addEventListener('click', e => { e.preventDefault(); applyDiscountCode(); });
        input.addEventListener('keypress', e => { if (e.key === 'Enter') { e.preventDefault(); applyDiscountCode(); } });
      }
    }

    // EVENT DELEGATION
    if (!window.upsellEventsBound) {
      window.upsellEventsBound = true;

      document.addEventListener('click', function(e) {
        const removeDiscountBtn = e.target.closest('.js-remove-discount');
        if (removeDiscountBtn) {
          e.preventDefault();
          e.stopPropagation();
          removeDiscountBtn.style.opacity = '0.3';

          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ discount: '', sections: ['cart-drawer-section'] })
          })
          .then(res => res.json())
          .then(data => {
            if (data.sections && data.sections['cart-drawer-section']) {
              window.updateCartDrawerDOM(data.sections['cart-drawer-section']);
            } else {
              window.refreshCartSection();
            }
          })
          .catch(() => window.refreshCartSection());
          return;
        }

        const container = e.target.closest('#cart-drawer-upsell-container');
        if (container) {
          const pause = e.target.closest('.mm-upsell-pause');
          if (pause) {
            const paused = container.dataset.paused !== 'true';
            container.dataset.paused = String(paused);
            pause.setAttribute('aria-pressed', String(paused));
            pause.textContent = paused ? 'Wechsel starten' : 'Wechsel pausieren';
            return;
          }
          const addBtn = e.target.closest('.upsell-add-btn');
          if (addBtn) {
            e.preventDefault();
            e.stopPropagation();

            const variantId = addBtn.getAttribute('data-variant-id');
            if (!variantId) return;

            addBtn.disabled = true;
            addBtn.style.opacity = '0.5';

            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }], sections: ['cart-drawer-section'] })
            })
            .then(res => res.json())
            .then(data => {
              if (window.updateCartDrawerDOM && data.sections && data.sections['cart-drawer-section']) {
                window.updateCartDrawerDOM(data.sections['cart-drawer-section']);
              } else {
                window.refreshCartSection();
              }
            })
            .catch(() => window.refreshCartSection());
            return;
          }

          const card = e.target.closest('.upsell-card-inner');
          if (card) {
            const url = card.getAttribute('data-url');
            if (url && url !== '#') {
              window.location.href = url;
            }
            return;
          }

          const prevBtn = e.target.closest('.upsell-arrow-btn.prev');
          if (prevBtn) {
            const track = container.querySelector('.upsell-slider-track');
            if (track) {
              const slide = track.querySelector('.upsell-card-slide');
              const step = slide ? slide.getBoundingClientRect().width + 10 : 260;
              track.scrollBy({ left: -step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
            }
            return;
          }

          const nextBtn = e.target.closest('.upsell-arrow-btn.next');
          if (nextBtn) {
            const track = container.querySelector('.upsell-slider-track');
            if (track) {
              const slide = track.querySelector('.upsell-card-slide');
              const step = slide ? slide.getBoundingClientRect().width + 10 : 260;
              const maxScroll = track.scrollWidth - track.clientWidth;
              if (track.scrollLeft >= maxScroll - 10) {
                track.scrollTo({ left: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
              } else {
                track.scrollBy({ left: step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
              }
            }
            return;
          }

          const dot = e.target.closest('.upsell-dot');
          if (dot) {
            const track = container.querySelector('.upsell-slider-track');
            const dots = Array.from(container.querySelectorAll('.upsell-dot'));
            const idx = dots.indexOf(dot);
            if (track && idx !== -1) {
              const slide = track.querySelector('.upsell-card-slide');
              const step = slide ? slide.getBoundingClientRect().width + 10 : 260;
              track.scrollTo({ left: idx * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
            }
            return;
          }
        }
      });
    }

    // MUTATION OBSERVER: REAGIERT SOFORT AUF (+, -, LÖSCHEN DER PRODUKTE)
    if (!window.upsellObserverActive) {
      window.upsellObserverActive = true;

      const observer = new MutationObserver(() => {
        initCustomDiscount();
        const container = document.getElementById('cart-drawer-upsell-container');
        if (container && !container.dataset.initialized) {
          renderUpsellSlider();
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCustomDiscount);
      document.addEventListener('DOMContentLoaded', renderUpsellSlider);
    } else {
      initCustomDiscount();
      renderUpsellSlider();
    }

  })();
  } catch(e) { console.error(e); }
})();

})();
